import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ResponsiveStore} from '../models/responsive-store.model';
import {DeviceDetectorService} from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService {
  private _responsiveSubject: BehaviorSubject<ResponsiveStore>;
  private _dataStore = new ResponsiveStore(); // This is where we will store our data in memory

  constructor(
    private deviceService: DeviceDetectorService
  ) {
    this._responsiveSubject = new BehaviorSubject(null);
    this.initDeviceDetector();
  }

  getResponsiveStoreObservable(): Observable<ResponsiveStore> {
    return this._responsiveSubject.asObservable();
  }

  initDeviceDetector(): void {
    this._dataStore.isMobile = this.isMobile();
    this._dataStore.isTablet = this.isTablet();
    this._dataStore.isDesktop = this.isDesktop();
    this.refresh();
  }

  isMobile(): boolean {
    return this.deviceService.isMobile();
  }

  isTablet(): boolean {
    return this.deviceService.isTablet();
  }

  isDesktop(): boolean {
    return this.deviceService.isDesktop();
  }

  setCurrentWindowWidth(val: number): void {
    this._dataStore.currentWindowWidth = val;
    this.refresh();
  }

  // Send the new value to the subscribers
  private refresh(): void {
    this._responsiveSubject.next({...this._dataStore});
  }
}
